import React, { useState } from 'react';
import { Menu, MenuItem, Box, Divider } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
// import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Avatar from '../../components/styled_api/HeaderAvatar';

const ProfileDropdown: React.FC = () => {
  // #region Constants
  const { logout, setActivePage, user } = useAuth();
  const initial = user?.firstName ? user?.firstName[0].toUpperCase() : 'U';

  // #endregion

  // #region State Variables
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  // #endregion

  // #region Handle Functions
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  // #endregion

  return (
    <Box
      sx={{
        display: 'flex',
        padding: '8px 0',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
      }}
    >
      {/* Profile avatar */}
      <Tooltip title='Account Settings'>
        <IconButton
          onClick={handleMenuOpen}
          sx={{ p: 0.5, borderRadius: '50%' }}
        >
          <Avatar className='avatar' initial={initial} src={user?.imageUrl ?? undefined} />
        </IconButton>
      </Tooltip>
      {/* Dropdown menu after clicking profile */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        slotProps={{
          paper: {
            className: 'myMenuPaper',
            sx: {
              zIndex: theme => theme.zIndex.appBar + 2,
              mt: 'auto !important',
            },
          },
          root: { className: 'myMenuRoot' },
        }}
      >
        <MenuItem
          onClick={() => {
            setActivePage('users');
            handleMenuClose();
          }}
        >
          My profile
        </MenuItem>

        <Divider 
          sx={{
            backgroundColor: theme =>
              theme.palette.divider,
          }}
        />

        <MenuItem
          onClick={() => {
            logout();
            handleMenuClose();
          }}
          sx={{
            color: '#d32f2f', //  $errorm
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ProfileDropdown;
